import axios from 'axios'
import gql from "graphql-tag";
import {
  getUploadImageUrl,
  getUploadFileUrl,
  getUploadVideoUrl
} from './global.gql'

export default {
  // baseUrl: 'http://localhost:3000/',
  baseUrl: 'http://47.75.105.162:3000/',
  // baseUrl:'http://58.33.91.86:12401/',
  // baseUrl:'http://47.75.105.162:3000/',
  // baseUrl:'http://192.168.32.137:3000/',
  // 本地
  // baseUrl:'http://192.168.32.174:3000/',
  // baseUrl:'http://192.168.32.177:41114/',
  // baseUrl:'http://58.33.91.85:12401/',
  city: {
    Beijing: "北京", Changsha: "长沙", Chengdu: "成都", Chongqing: "重庆", Dalian: "大连",
    Dongguan: "东莞", Dongying: "东营", Fuzhou: "福州", Guangzhou: "广州", Guiyang: "贵阳", Haikou: "海口", Handan: "邯郸",
    Hangzhou: "杭州", Harbin: "哈尔滨", Hefei: "合肥", Luzhou: "泸州", Nanjing: "南京", Nanning: "南宁", Neijiang: "内江",
    Qingdao: "青岛", Quanzhou: "泉州", Shanghai: "上海", Shenzhen: "深圳", Tianjin: "天津", Wuxi: "无锡", Xiangtan: "湘潭",
    Xincheng: "新城", Xuzhou: "徐州", Yingtan: "鹰潭",
  },
  ENUM: {
    COMPETITION_STATE: ['未开始', '报名中', '提交作品中', '投票中', '已结束'],
    URBANDREAMCARDS: [
      {
        id: null,
        name: '',
        englishName: 'ALL',
        borderColor: '#F3AC00',
        icon: ''
      },
      {
        id: 288,
        name: '自然',
        englishName: 'Nature',
        borderColor: '#89A16C',
        icon: 'iconziran'
      },
      {
        id: 289,
        name: '治理',
        englishName: 'Goverance',
        borderColor: '#818DAA',
        icon: 'iconzhili',
      },
      {
        id: 290,
        name: '居住',
        englishName: 'Live',
        borderColor: '#C0CA33',
        icon: 'iconjuzhu',
      },
      {
        id: 291,
        name: '出行',
        englishName: 'Travel',
        borderColor: '#A1887F',
        icon: 'iconchuhang',
      },
      {
        id: 292,
        name: '医疗',
        englishName: 'Health Care',
        borderColor: '#90A4AE',
        icon: 'iconyiliao',
      },
      {
        id: 296,
        name: '创新',
        englishName: 'Innovation',
        borderColor: '#9575CD',
        icon: 'iconchuangxin',
      },
      {
        id: 294,
        name: '产业',
        englishName: 'Industry',
        borderColor: '#FFB74D',
        icon: 'iconchanye',
      },
      {
        id: 295,
        name: '基础设施',
        englishName: 'Infrastructure',
        borderColor: '#E57373',
        icon: 'iconjichusheshi',
      },
      {
        id: 293,
        name: '教育',
        englishName: 'Education',
        borderColor: '#64B5F6',
        icon: 'iconjiaoyu',
      },
      {
        id: 297,
        name: '商业和娱乐生活',
        englishName: 'Commercial Life',
        borderColor: '#F48FB1',
        icon: 'iconyule',
      },
    ],
  },

  trimStr(str) {
    if (str) {
      var trimLeft = /^\s+/,
        trimRight = /\s+$/;
      return str.replace(trimLeft, "").replace(trimRight, "");
    }
    return null
  },


  setHttpHeader(url) {
    if (url.substr(0, 4) != 'auth') {
      console.log('setToken', this.getToken())
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + this.getToken();
    }
  },
  httpGet(self, url, data) {
    return new Promise((resolve, reject) => {
      // axios.get(this.baseUrl + url + "?" + this.getHttpData(data)).then((res)=>{
      this.setHttpHeader(url)
      axios.get(this.baseUrl + url, { params: data }).then((res) => {
        if (res.data.status == 1) {
          resolve(res.data)
        } else {
          this.error(self, res.data.message, '')
          reject(res.data.message)
        }
      }).catch((res) => {
        this.error(self, 'Network Error', '')
      })
    })
  },
  checkMobilePhone(self, mobile) {
    if (!mobile) {
      this.error(self, this.ERROR.PHONE_ERROR)
      return false
    }
    if (!self.$validator.isMobilePhone(mobile, ['zh-CN'])) {
      this.error(self, this.ERROR.PHONE_ERROR)
      return false
    }
    return true
  },
  // checkNull(self,checkData,showName){
  //   if(!checkData){
  //     this.error(self,showName+this.ERROR.NORMAL_ERROR) 
  //     return false
  //   }
  //   return true
  // },
  checkArrayNull(self, checkData, showName) {
    if (!checkData.length) {
      this.error(self, showName)
      return false
    }
    return true
  },
  checkEmail(self, email) {
    console.log(self.$validator.isEmail(email))
    if (!self.$validator.isEmail(email)) {
      this.error(self, this.ERROR.EMAIL_ERROR)
      return false
    }
    return true
  },
  checkPassword(self, password) {
    if (!self.$validator.isByteLength(password, { min: 8, max: 20 })) {
      this.error(self, this.ERROR.PASSWORD_LENGTH)
      return false
    }
    if (!(/[a-z].*[0-9]|[0-9].*[a-z]/i.test(password))) {
      this.error(self, this.ERROR.PASSWORD_LETTER)
      return false
    }
    return true
  },
  checkNull(params) {
    for (var key in params) {
      if (params[key] === '') {
        params[key] = null
      }
    }
    return params
  },
  // graphqlMutation
  // gqlName
  GraphqlMutation(self, gqlName, params) {
    return new Promise((resolve, reject) => {
      self.$apollo.mutate({
        mutation: gqlName,
        variables: params,
      })
        .then((data) => {
          resolve(Object.values(data.data)[0])
        }).catch((error) => {
          console.log(JSON.stringify(error))
          // != undefined
          if (error.networkError.result) {
            reject(error.networkError.result.errors[0])
            this.error(self, 'Network Error', '')
          }
          // TODO: 统一处理网络错误及token失效
        })
    })
    // return new Promise((resolve, reject) => {
    //   self.$apollo.mutate(params).then((res) => {
    //     resolve(res)
    //   }).catch((err)=>{
    //     reject(err)
    //     this.error(self,'网络错误','')
    //   })
    // })

  },
  async uploadVideo(self, params) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      console.log(file)
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]
      const res = await this.GraphqlMutation(self, getUploadVideoUrl, {
        // mutation: gql`mutation ($fileName:String!) {
        //   getUploadVideoUrl(fileName:$fileName) {
        //     data
        //   }
        // }`,
        // // Parameters
        // variables: {
        fileName: name
        // },
      })
      // this.uploadUrl = res.data.getUploadFileUrl.data
      axios.put(res.data, file).then((res2) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadFile(self, params) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]

      const res = await this.GraphqlMutation(self, getUploadFileUrl, {
        fileName: name
      })
      axios.put(res.data, file).then((res2) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadFileWithName(self, params, filename1) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      const filename = file.name.split('.')
      const name = filename1 + '.' + filename[filename.length - 1]

      const res = await this.GraphqlMutation(self, getUploadFileUrl, {
        fileName: name
      })
      axios.put(res.data, file).then((res2) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadTextFile(self, params) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]

      const res = await this.GraphqlMutation(self, getUploadFileUrl, {
        fileName: file.name
      })
      axios.put(res.data, file).then((res2) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadImage(self, params, config) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      console.log(file)
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]
      const res = await this.GraphqlMutation(self, getUploadImageUrl, {
        // mutation: gql`mutation ($fileName:String!) {
        //   getUploadImageUrl(fileName:$fileName) {
        //     data
        //   }
        // }`,
        // // Parameters
        // variables: {
        fileName: name
        // },
      })
      // this.uploadUrl = res.data.getUploadFileUrl.data
      axios.put(res.data, file, config).then((res2) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadImageWithConfig(self, params, config) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      console.log(file)
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]
      const res = await this.GraphqlMutation(self, getUploadImageUrl, {
        fileName: name
      })


      console.log(res.data)
      axios.put(res.data, file, config).then((res2) => {
        resolve(res2.config)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadVideoWithConfig(self, params, config) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      console.log(file)
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]
      const res = await this.GraphqlMutation(self, getUploadVideoUrl, {
        fileName: name
      })
      axios.put(res.data, file, config).then((res2) => {
        resolve(res2.config)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  async uploadFileWithConfig(self, params, config) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      console.log(file)
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]
      const res = await this.GraphqlMutation(self, getUploadVideoUrl, {
        fileName: name
      })
      console.log(res.data)
      axios.put(res.data, file, config).then((res2) => {
        resolve(res2.config)
      }).catch((err) => {
        reject(err);
      })
    })
  },
  // gqlName
  GraphqlQuery(self, gqlName, params) {
    // console.log(11111111321313123,self,gqlName,params)
    return new Promise((resolve, reject) => {

      self.$apollo.query({
        query: gqlName,
        variables: params,
      })
        .then((data) => {
          resolve(Object.values(data.data)[0])

        }).catch((error) => {
          if (error.networkError.result) {
            reject(error.networkError.result.errors[0])
            this.error(self, '网络错误', '')
          }
        })
    })
    // return new Promise((resolve, reject) => {
    //   self.$apollo.query(params).then((res) => {
    //     resolve(res)
    //   }).catch((err)=>{
    //     reject(err)
    //     this.error(self,'网络错误','')
    //   })
    // })
  },
  httpPost(self, url, data) {
    return new Promise((resolve, reject) => {
      // axios.get(this.baseUrl + url + "?" + this.getHttpData(data)).then((res)=>{
      this.setHttpHeader(url)
      axios.post(this.baseUrl + url, data).then((res) => {
        if (res.data.status == 1) {
          resolve(res.data)
        } else {
          this.error(self, res.data.message, '')
          reject(res.data.message)
        }
      }).catch((res) => {
        this.error(self, '网络错误', '')
      })
    })
  },
  httpDelete(self, url, data) {
    return new Promise((resolve, reject) => {
      // axios.get(this.baseUrl + url + "?" + this.getHttpData(data)).then((res)=>{
      this.setHttpHeader(url)
      axios.delete(this.baseUrl + url, data).then((res) => {
        if (res.data.status == 1) {
          resolve(res.data)
        } else {
          this.error(self, res.data.message, '')
          reject(res.data.message)
        }
      }).catch((res) => {
        this.error(self, '网络错误', '')
      })
    })
  },
  httpPut(self, url, data) {
    return new Promise((resolve, reject) => {
      // axios.get(this.baseUrl + url + "?" + this.getHttpData(data)).then((res)=>{
      this.setHttpHeader(url)
      axios.put(this.baseUrl + url, data).then((res) => {
        if (res.data.status == 1) {
          resolve(res.data)
        } else {
          this.error(self, res.data.message, '')
          reject(res.data.message)
        }
      }).catch((res) => {
        this.error(self, 'Network', '')
      })
    })
  },
  setLocalData(key, tempPer) {
    localStorage.setItem(key, JSON.stringify(tempPer))
  },
  getLocalData(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  setPermission(tempPer) {
    localStorage.setItem('icpermission', JSON.stringify(tempPer))
  },
  getPermission() {
    return JSON.parse(localStorage.getItem('icpermission'))
  },
  getToken: function () {
    return localStorage.getItem('ictoken')
  },
  setToken: function (token) {
    localStorage.setItem('ictoken', token)
  },
  getState: function () {
    return JSON.parse(localStorage.getItem('state'))
  },
  setState: function (data) {
    localStorage.setItem('state', JSON.stringify(data))
  },
  getUser: function () {
    return JSON.parse(localStorage.getItem('icuser'))
  },
  setUser: function (caruser) {
    localStorage.setItem('icuser', JSON.stringify(caruser))
  },
  logout: function () {
    localStorage.removeItem('icuser')
    localStorage.removeItem('ictoken')
    localStorage.removeItem('icpermission')
  },
  getDay(day, isyear) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds);
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    if (isyear) {
      return tYear + '/' + tMonth + "/" + tDate;
    } else {
      return tMonth + "/" + tDate;
    }

  },
  doHandleMonth(month) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  },

  async uploadImageTwo(self, params, config) {
    return new Promise(async (resolve, reject) => {
      const file = params.file
      console.log(params.file)
      const filename = file.name.split('.')
      const name = self.$uuid.v1() + '.' + filename[filename.length - 1]

      this.GraphqlMutation(self, getUploadImageUrl, {
        fileName: name
      })
        .then((res) => {
          axios.put(res.data, file, config).then((res2) => {
            resolve(res2.config)
          }).catch((err) => {
            reject(err);
          })
        })
    })
  },

  ////////////////////////////////////////////////////////////////////////
  /////////////                已修复方法                    //////////////
  ///////////////////////////////////////////////////////////////////////

  // 下载二进制文件
  downloadFile(data, filename) {
    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
    );
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", filename + ".xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  // 成功提示
  success(obj, msg, url) {
    let el = obj.$message({
      message: msg,
      type: 'success',
      duration: '2000',
      onClose: function () {
        if (url !== '' && url != null) {
          obj.$router.push(url)
        }
      }
    }).$el
    if (el) {
      el.style.cssText = 'z-index:9000;background:white;margin-top:40px; border:2px solid #5470C6;border-radius: 25px;'
    }
  },
  // 失败提示
  error(obj, msg, url) {
    let el = obj.$message({
      message: msg,
      type: 'error',
      duration: '2000',
      onClose: function () {
        if (url !== '' && url != null) {
          obj.$router.push(url)
        }
      }
    }).$el;
    if (el) el.style.cssText = 'z-index:9000;background:white;margin-top:40px; border:2px solid #5470C6; border-radius: 25px;'
  },
}



// WEBPACK FOOTER //
// ./src/global/global.js